// components/CompanyLogin.js
import React, { useState } from 'react';
import axios from 'axios';
import './Login.css';

const API_URL = process.env.REACT_APP_API_URL;

const CompanyLogin = ({ onLogin }) => {
  const [companyNumber, setCompanyNumber] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();  // prevent page reload on submit
    if (!companyNumber || !password) {
      setError('Please enter company number and password');
      return;
    }
    setLoading(true);
    setError('');
    try {
      const response = await axios.post(`${API_URL}/login/company`, {
        companyNumber,
        password,
      });
      onLogin(response.data, 'company');
    } catch (err) {
      setError(err.response?.data?.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h2>Company Login</h2>

        <form onSubmit={handleLogin} className="login-form">
          <div className="form-group">
            <label htmlFor="companyNumber">Company Number</label>
            <input
              type="text"
              id="companyNumber"
              value={companyNumber}
              onChange={(e) => setCompanyNumber(e.target.value)}
              placeholder="Enter mobile number"

            />
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              type="password"
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter password"

            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? 'Logging in...' : 'Login'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CompanyLogin;
